import { baseURL } from "./ServiceUtil";
import { customAjax } from "../components/ErrorHandler";
import { PostLocationItem } from "../models/Location";

export const postLocation = (locationPayload: PostLocationItem) =>
  customAjax(`${baseURL}/locations`, "POST", locationPayload);
